<script setup lang="ts">
import type { IService } from '@types'
import TimeDuration from '@booking/components/TimeDuration.vue'
import { ServiceTypes } from '@types'
import { getServiceMinLength } from '@utils/priceLibrary/service'

withDefaults(
  defineProps<{
    service?: IService
  }>(),
  {
    service: () => ({}) as IService,
  },
)
</script>

<template lang="pug">
span
  template(v-if="service.type === ServiceTypes.Rent") {{ $t('word.from.time.base') }}&nbsp;
  TimeDuration(:m="getServiceMinLength(service)")
</template>
